import React from 'react';
import './form-error-message.scss';
import { ErrorMessage } from 'react-hook-form';
import { FormErrorMessageProps } from './form-error-message-props';

/**
 * Extends the `react-use-form` ErrorMessage component to display
 * form field errors.
 *
 * The `name` prop must be the same as the name of the input these errors are for.
 * @param props
 */
export const FormErrorMessage: React.FC<FormErrorMessageProps> = (props) => {
  const {
    name,
    className,
    errors,
  } = props;

  return (
    <span className={`sg-form-error-message ${className}`}>
      <ErrorMessage
        errors={errors}
        name={name}
      >
        {({ message, messages }) => (
          <>
            {/** Single message */}
            {message && !messages && (
              <span className="error">{message}</span>
            )}
            {/** Multiple messages */}
            {messages && (
              Object.entries(messages).map(([type, m]) => (
                message && <span className="error" key={type}>{m}</span>
              ))
            )}
          </>
        )}
      </ErrorMessage>
    </span>
  );
};
